/** Prevent the document from scrolling (e.g. while a modal or top sheet is open). */
export function lockPageScroll(): () => void {
  const scrollY = window.scrollY;
  const { body } = document;
  const html = document.documentElement;

  const prev = {
    bodyOverflow: body.style.overflow,
    bodyPosition: body.style.position,
    bodyTop: body.style.top,
    bodyWidth: body.style.width,
    htmlOverflow: html.style.overflow,
  };

  body.style.overflow = 'hidden';
  body.style.position = 'fixed';
  body.style.top = `-${scrollY}px`;
  body.style.width = '100%';
  html.style.overflow = 'hidden';

  return () => {
    const y = Math.abs(parseInt(body.style.top || '0', 10)) || scrollY;
    body.style.overflow = prev.bodyOverflow;
    body.style.position = prev.bodyPosition;
    body.style.top = prev.bodyTop;
    body.style.width = prev.bodyWidth;
    html.style.overflow = prev.htmlOverflow;
    window.scrollTo(0, y);
  };
}

/** Lock scroll without changing scroll position (no body position:fixed jump on unlock). */
export function lockPageScrollOverflowOnly(): () => void {
  const { body } = document;
  const html = document.documentElement;
  const prev = {
    bodyOverflow: body.style.overflow,
    htmlOverflow: html.style.overflow,
  };
  body.style.overflow = 'hidden';
  html.style.overflow = 'hidden';
  return () => {
    body.style.overflow = prev.bodyOverflow;
    html.style.overflow = prev.htmlOverflow;
  };
}
